import { apiGet, apiPatch } from "../client";
import type { SalesTransactionListResponseApi } from "../models/salesTransaction";

export async function getAllSalesTransactions(params?: {
  outstandingOnly?: boolean;
  search?: string;
  limit?: number;
}): Promise<SalesTransactionListResponseApi> {
  const searchParams = new URLSearchParams();
  if (params?.outstandingOnly) searchParams.append("outstandingOnly", "true");
  if (params?.search) searchParams.append("search", params.search);
  if (params?.limit) searchParams.append("limit", String(params.limit));
  const query = searchParams.toString();
  return apiGet<SalesTransactionListResponseApi>(
    `transactions/sales${query ? `?${query}` : ""}`,
  );
}

export async function updateSalesTransactionCategory(
  id: number,
  category: string,
): Promise<void> {
  return apiPatch<void>(`transactions/sales/${id}/category`, { category });
}
